"use client";

import Link from "next/link";
import React from "react";

import LabelButtonWrapper from "@/components/atoms/button-wrapper/button-wrapper";
import RichText from "@/components/atoms/rich-text/rich-text";
import { CreateAccountAreaProps } from "@/types/policy-document-types";

import Style from "../policy-document-section.module.css";

function CreateAccount({
  myAccountTitle,
  myAccountFooterContent,
  myAccountContent,
  myAccountBtnLabel,
  myAccountCreateAccountLink,
}: Readonly<CreateAccountAreaProps>) {
  return (
    <div
      className="flex flex-col gap-spacing-m md:gap-spacing-l "
      data-testid="createAccount-testid"
    >
      <h1 className=" font-header-font  text-text-title text-[20px] md:text-[31px] leading-[27.6px] md:leading-[34.1px]">
        {myAccountTitle ?? "Create your MyStaysure account"}
      </h1>
      <div className={`${Style.list_block} `}>
        <RichText
          richText={myAccountContent ?? ""}
          className="leading-[27px] text-xs"
        />
      </div>
      <div className=" w-[196px] ">
        <Link
          href={myAccountCreateAccountLink}
          target="_blank"
          className="w-full"
        >
          <LabelButtonWrapper
            data-testid="create-account-button"
            id="create-account-button"
            isDisabled={false}
            label={myAccountBtnLabel ?? "Create an account"}
            hierarchy="primary"
            className="md:max-w-xs"
            type="button"
          />
        </Link>
      </div>
      <div>
        <RichText
          richText={myAccountFooterContent ?? ""}
          className={`${Style.richtext} leading-[27px] text-xs`}
        />
      </div>
    </div>
  );
}

export default CreateAccount;
